<div>
    <h2>{{'mantenimientoConfecciones.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoConfecciones.filters.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')" [disabled]="disabledEtiquetador" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoConfecciones.filters.denominacion' | translate}}</label>
                <app-filterable-list [itemsList]="denominacionesList" [selectedItem]="filtersForm.get('denominacion')" [disabled]="disabled" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoConfecciones.filters.confeccion' | translate}}</label>
                <input type="text" formControlName="desConfeccion">
            </div>
            <!-- <div class="entry-5">
                <label>{{'mantenimientoConfecciones.filters.eliminados' | translate}}</label>
                <app-filterable-list [itemsList]="yesNo" [selectedItem]="filtersForm.get('eliminados')" [placeHolder]="false"></app-filterable-list>
            </div> -->
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoConfecciones.filters.confeccionActiva' | translate}}</label>
                <app-filterable-list [itemsList]="yesNo" [selectedItem]="filtersForm.get('activo')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left-next">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
            <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons" *ngIf="(pestanaActiva === 1 && confeccionesCaja) || (pestanaActiva === 2 && confeccionesPallet)">
      <i class="fas fa-file-pdf" (click)="exportModal = 1; fileType = 'Pdf'"
        [ngClass]="{'disabled': (pestanaActiva === 1 && (!confeccionesCaja || confeccionesCaja.length < 1)) ||
                                (pestanaActiva === 2 && (!confeccionesPallet || confeccionesPallet.length < 1))}"
        title="{{'global.modalInformes.titulo' | translate}} PDF"></i>
      <i class="fas fa-file-csv" (click)="exportModal = 3; fileType = 'Csv'"
        [ngClass]="{'disabled': (pestanaActiva === 1 && (!confeccionesCaja || confeccionesCaja.length < 1)) ||
                                (pestanaActiva === 2 && (!confeccionesPallet || confeccionesPallet.length < 1))}"
        title="{{'global.modalInformes.titulo' | translate}} CSV"></i>
      <i *ngIf="pestanaActiva === 1" class="fa-solid fa-circle-question" (click)="openDocHelp(1)" title="{{'global.obtenerAyuda' | translate}}"></i>
      <i *ngIf="pestanaActiva === 2" class="fa-solid fa-circle-question" (click)="openDocHelp(2)" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <section class="tabs">
        <ul>
            <li [ngClass]="{'active': pestanaActiva === 1}" (click)="showConfeccionesCaja()">{{'mantenimientoConfecciones.confeccion.tituloCaja' | translate}}</li>
            <li *ngIf="permitePallets" [ngClass]="{'active': pestanaActiva === 2}" (click)="showConfeccionesPallet()">{{'mantenimientoConfecciones.confeccion.tituloPallet' | translate}}</li>
        </ul>
        <content>
            <app-confecciones-caja *ngIf="pestanaActiva === 1" [confeccionesCaja]="confeccionesCaja" (refresh)="refresh($event)" (sort)="sort($event)" ></app-confecciones-caja>
            <app-confecciones-pallet *ngIf="pestanaActiva === 2" [confeccionesPallet]="confeccionesPallet" (refresh)="refresh($event)" (sort)="sort($event)"></app-confecciones-pallet>
            <app-paginator
                *ngIf="(pestanaActiva === 1 && confeccionesCaja && confeccionesCaja.length > 0) || (pestanaActiva === 2 && confeccionesPallet && confeccionesPallet.length > 0)"
                [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1" [totalItems]="totalItems"
                [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
                (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
        </content>
        <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event">
        </app-toast>
    </section>
</div>
<div class="modal" *ngIf="exportModal > 0">
  <div class="modal-content">
    <header>
      <h4>{{'global.modalInformes.titulo' | translate}} {{exportModal === 1 ? 'PDF' : exportModal === 2 ? 'Excel' : 'CSV'}}</h4>
      <i class="fas fa-times" (click)="exportModal = 0"></i>
    </header>
    <content>
      <button (click)="export(1)">{{'global.modalInformes.general' | translate}}</button>
      <button (click)="export(2)">{{'global.modalInformes.detallado' | translate}}</button>
    </content>
  </div>
</div>
